import { render, staticRenderFns } from "./customize_sacred_object.vue?vue&type=template&id=6d6c9ec3&scoped=true"
import script from "./customize_sacred_object.vue?vue&type=script&lang=js"
export * from "./customize_sacred_object.vue?vue&type=script&lang=js"
import style0 from "./customize_sacred_object.vue?vue&type=style&index=0&id=6d6c9ec3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c9ec3",
  null
  
)

export default component.exports